export default "__VITE_ASSET__6j_1QmZ7__"